import { ref, watch } from 'vue'

const STORAGE_KEY = 'highContrastMode'
const isHighContrast = ref(false)

export function useHighContrast() {
  const toggleHighContrast = () => {
    isHighContrast.value = !isHighContrast.value
    localStorage.setItem(STORAGE_KEY, String(isHighContrast.value))
    applyTheme()
  }

  const applyTheme = () => {
    if (isHighContrast.value) {
      document.documentElement.classList.add('high-contrast')
    } else {
      document.documentElement.classList.remove('high-contrast')
    }
  }

  const removeHighContrastClass = () => {
    isHighContrast.value = false
    document.documentElement.classList.remove('high-contrast')
  }

  const restoreHighContrastIfEnabled = () => {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'true') {
      isHighContrast.value = true
      applyTheme()
    } else {
      // Varsayılan olarak inaktif
      isHighContrast.value = false
      document.documentElement.classList.remove('high-contrast')
    }
  }

  const initHighContrast = () => {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'true') {
      isHighContrast.value = true
    }
    applyTheme()
  }

  watch(isHighContrast, () => {
    applyTheme()
  })

  return {
    isHighContrast,
    toggleHighContrast,
    initHighContrast,
    removeHighContrastClass,
    restoreHighContrastIfEnabled,
  }
}

